const Inspiration = () => {
  return (
    <div className='flex justify-center mt-5'>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/KdtPNRzuKrk"
        title="Hacking Harvard&#39;s facebooks and building Facemash – The Social Network (2010)"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Inspiration;
